export const Status = {
  IN_PROGRESS: 'pr',
  TO_DO: 'td',
  DONE: 'd',
} as const;

export const TaskKeys = {
  INDEX: 'i',
  ASSIGNEE: 'asg',
  USER: 'u',
  PARAGRAPH_ID: 'p_id',
  TIME: 't',
  VOTES: 'v',
  STATUS: 's',
  DESCRIPTION: 'd',
  WATCHERS: 'w',
  REPLY: 'r',
} as const;
